import { LanguageCode } from "../../../../i18n/language";

/**
 * Translation resources for the socials component.
 */
export interface SocialsResourceTranslations {
    title: string;
}

/**
 * Overall socials translation resources structure.
 */
type SocialsResource = {
    [language in LanguageCode]: SocialsResourceTranslations;
};

export const socialsResource: SocialsResource = {
    nl: {
        title: 'Socials'
    },
    en: {
        title: 'Socials'
    }
};